import { ApeironLinkButton, DEFAULT_ANIMATE_DURATION } from '@apeiron/temp'
import { Box, styled, Typography, useMediaQuery } from '@mui/material'
import theme from '@src/styles/theme'

const Container = styled(ApeironLinkButton)`
  --background-color: #4c7498;
  border-radius: 5px;
  gap: 10px;
  padding: 15px 40px;
  text-align: center;
  transition: filter ${DEFAULT_ANIMATE_DURATION}ms,
    transform ${DEFAULT_ANIMATE_DURATION}ms;

  :hover {
    transform: translateY(-3px);
    filter: brightness(1.1);
  }

  :hover p {
    text-decoration: underline;
  }

  :hover div {
    width: 20px;
  }
`

const Arrow = styled(Box)`
  overflow: hidden;
  transition: width ${DEFAULT_ANIMATE_DURATION}ms;
  width: 0px;
`

const Text = styled(Typography)`
  font-weight: 300;
  line-height: 16px;
`

type Props = {
  title: string
  href: string
}

const LinkButtonView = ({ title, href }: Props) => {
  const isMobile = useMediaQuery(theme.breakpoints.down('res768'))

  return (
    <Container url={href}>
      {!isMobile && <Arrow>{'>> '}</Arrow>}
      <Text>{title}</Text>
      {!isMobile && <Arrow>{'<<'}</Arrow>}
    </Container>
  )
}

export default LinkButtonView
